import { useState, useEffect } from 'react';
import firebase from 'firebase/app';

// Claim Status
//  status: 'allowed' | 'limited' | 'loading' | 'error'
//  count: number

export default function useClientTemplateClaimStatus(client, tag) {
    const { clientId } = client || {};
    const { templateTagId, limitCount } = tag || {};
    const [claimStatus, setClaimStatus] = useState({ status: 'loading', count: 0 });
    const db = firebase.firestore();

    const getTags = async (limitCount, clientId, templateTagId) => {
        let tags = [];
        try {
            const querySnapshot = await db
                .collection('tags')
                .where('templateTagId', '==', templateTagId)
                .where('clientId', '==', clientId)
                .where('status', '==', 'live')
                .limit(limitCount + 1)
                .get();
            tags = querySnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));
        } catch (error) {
            console.error('[ERROR] Failed to fetch tags:', error);
            throw error; // Propagate the error
        }
        return tags;
    };

    useEffect(() => {
        const fetchTags = async () => {
            setClaimStatus({ status: 'loading', count: 0 }); // Reset status to loading
            if (limitCount && clientId && templateTagId) {
                try {
                    const tags = await getTags(limitCount, clientId, templateTagId);
                    const tagCount = tags.length;
                    setClaimStatus({
                        status: tagCount >= limitCount ? 'limited' : 'allowed',
                        count: tagCount,
                        templateTagId,
                    });
                } catch (error) {
                    setClaimStatus({
                        status: 'error',
                        count: 0,
                        error: 'Failed to fetch tags',
                        templateTagId,
                    });
                }
            } else {
                setClaimStatus({
                    status: 'allowed',
                    count: 0,
                    templateTagId,
                }); // No tags found or not limited
            }
        };

        fetchTags();
    }, [templateTagId, limitCount, clientId]);

    return claimStatus;
}
